<template>
    <div class="modal fade" id="pg-category-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"  aria-hidden="true" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-black font-normal" id="exampleModalLongTitle">Add new category</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body bg-white">
                    <div class="mt-2">
                        <label class="text-black">Name<span class="text-danger">*</span></label>
                        <input class="form-control" type="text" placeholder="Name" v-model="pgCategoryForm.name"
                               :class="[({'border-red' : pgCategoryForm.errors ? pgCategoryForm.errors.has('name') : ''})]"
                               @input="resetValidation('name')">
                        <div class="text-red text-xs" v-if="pgCategoryForm.errors && pgCategoryForm.errors.has('name')">{{
                                pgCategoryForm.errors ? pgCategoryForm.errors.get('name') : ''}}
                        </div>
                    </div>
                    <div class="form-check my-2">
                        <input type="checkbox" v-model="pgIsSubCategory" class="form-check-input" id="exampleCheck1">
                        <label class="form-check-label" for="exampleCheck1">Is a sub-category</label>
                    </div>
                    <div v-if="pgIsSubCategory">
                        <label class="text-black">Select Category</label>
                        <treeselect v-model="pgCategoryForm.parent_id" :options="allPGCategories"/>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="save">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import Form from "../../../../../utils/form";

export default {
    name: 'pg-category-modal',
    props: ['allPGCategories'],
    components: {Treeselect},
    data() {
        return {
            pgIsSubCategory: false,
            pgCategoryForm: new Form({
                name: null,
                parent_id: null,
            })
        }
    },
    methods: {
        open() {
            $('#pg-category-modal').modal('show');
        },
        close() {
            $('#pg-category-modal').modal('hide');
        },
        resetValidation(field) {
            delete this.pgCategoryForm.errors.errors[field];
        },
        resetForm() {
            this.pgIsSubCategory = false;
            this.pgCategoryForm.name = null;
            this.pgCategoryForm.parent_id = null;
        },
        save(){
            let self = this;
            self.pgCategoryForm.post(route('api.proposal-settings.category.store-category')).then((data) => {
                self.close();
                self.resetForm();
                Bus.$emit('get-all-pg-categories');
            }).catch((error) => {
                //
            });
        }
    }
}
</script>
